// extracted by mini-css-extract-plugin
export default {"wrapper":"Reviews_wrapper__ei3h9","content":"Reviews_content__mLlQv","title":"Reviews_title__efZrh","sliderContainer":"Reviews_sliderContainer__PT1hf","item":"Reviews_item__nNx+o"};